module.exports = __webpack_public_path__ + "img/couples-089.a53aec1a.jpg";